import React, { useCallback } from 'react';
import { Modal } from '@vectord/components';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES,
  coursePauseRequestedRequestUpdateModalSelector,
  setCoursePauseRequestedDuration,
  setCoursePauseRequestedRequestUpdateModalStage,
  setCoursePauseRequestedStreakEnabled,
} from 'features/courseResume';
import CoursePauseRequestedRequestUpdateModalStages from '../CoursePauseRequestedRequestUpdateModalStages';

function CoursePauseRequestApproveModal() {
  const dispatch = useDispatch();
  const { modalStage } = useSelector(
    coursePauseRequestedRequestUpdateModalSelector
  );
  const isModalOpen =
    modalStage !== COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.notOpen;

  const handleModalClose = useCallback(() => {
    batch(() => {
      dispatch(
        setCoursePauseRequestedRequestUpdateModalStage(
          COURSE_PAUSE_REQUESTED_REQUEST_MODAL_STAGES.notOpen
        )
      );
      dispatch(setCoursePauseRequestedDuration(null));
      dispatch(setCoursePauseRequestedStreakEnabled(false));
    });
  }, [dispatch]);

  return (
    <Modal
      isOpen={isModalOpen}
      unMountOnClose
      onClose={handleModalClose}
      withoutHeader
      hasCloseButton={false}
      size="large"
    >
      <CoursePauseRequestedRequestUpdateModalStages />
    </Modal>
  );
}

export default CoursePauseRequestApproveModal;
